import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';

// Robust JWT decode (handles URL-safe base64 and padding) to pull out roles
export function parseJwt(token) {
  const base64Url = token.split('.')[1] || '';
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
  const jsonPayload = atob(padded);
  return JSON.parse(jsonPayload);
}

export async function getRoles(instance, account) {
  if (!instance || !account) return [];
  const response = await fetch('/api/config');
  const config = await response.json();
  const result = await instance.acquireTokenSilent({
    scopes: [config.SP_API_ENDPOINT],
    account,
  });
  const claims = parseJwt(result.accessToken);
  return Array.isArray(claims.roles) ? claims.roles : [];
}

export function hasAdminRole(roles) {
  if (!roles) return false;
  return roles.some((r) => typeof r === 'string' && /admin/i.test(r));
}

export function hasPowerbiUserRole(roles) {
  if (!roles) return false;
  return roles.some((r) => typeof r === 'string' && /powerbi-user/i.test(r));
}

export function hasBetaUserRole(roles) {
  if (!roles) return false;
  return roles.some((r) => typeof r === 'string' && /beta-user/i.test(r));
}

function RolesDisplay() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (account) {
      fetch('/api/config')
        .then(response => response.json())
        .then(config => {
          return instance.acquireTokenSilent({
            scopes: [config.SP_API_ENDPOINT],
            account,
          });
        })
        .then(result => {
          const claims = parseJwt(result.accessToken);
          setRoles(claims.roles || []);
        })
        .catch(err => console.error('Token acquisition or config fetch failed:', err));
    }
  }, [account, instance]);

  if (!account) return null;
  return (
    <>
      {roles.length > 0 ? roles.join(', ') : 'default access'}
    </>
  );
}
export default RolesDisplay;
